export enum ComparaisonOperator {
    Equality = 'Equality',
    Inequality = 'Inequality',
    GreaterThan = 'GreaterThan',
    GreaterOrEqualThan = 'GreaterOrEqualThan',
    LessThan = 'LessThan',
    LessOrEqualThan = 'LessOrEqualThan',
}
